/* product-store-header.tsx generated by @compiled/babel-plugin v3.0.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./product-store-header.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import { AtlassianLogo } from '@atlaskit/logo/atlassian/logo';
import { Box } from '@atlaskit/primitives/compiled';
import CrossIcon from '@atlaskit/icon/core/cross';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import IconButton from '@atlaskit/button/icon/button';
import { DrawerCloseButton } from '@atlaskit/drawer/drawer-close-button';
import { useViewStateContext } from '../context';
import { getDiscoverProductsPageRoute } from '@atlassiansox/product-store-react';
import { useIntl } from 'react-intl';
import { messages } from '../../../messages';
var styles = {
  container: "_1e0c1txw _2lx2vrvc _4cvr1e5h _4t3it9kd _ca0qv47k _n3tdv47k _19bv1ejb _u5f31ejb _1o3i1l7x _1doce4h9 _1il9nqa1 _ylrw1h6o",
  titleText: "_11c810sd _k48pi7a9 _ect41roz _syazazsu _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1ucau2gc",
  titleBox: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1e5h _1frtvrvc _ylrw1h6o"
};
export var ProductStoreHeader = function ProductStoreHeader() {
  var _useViewStateContext = useViewStateContext(),
    state = _useViewStateContext.state,
    setViewState = _useViewStateContext.setViewState;
  var showProductStoreTitle = useMemo(function () {
    return state.spa === 'product-store';
  }, [state]);
  var onBackToAllProductsClick = useCallback(function () {
    setViewState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        spa: 'product-store',
        route: getDiscoverProductsPageRoute()
      });
    });
  }, [setViewState]);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.container,
    testId: "cross-flow-support-header"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.titleBox,
    testId: "cross-flow-support-header-title"
  }, showProductStoreTitle ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AtlassianLogo, {
    appearance: "brand",
    size: "small"
  }), /*#__PURE__*/React.createElement(Box, {
    as: "p",
    xcss: styles.titleText
  }, formatMessage(messages.productStore))) : /*#__PURE__*/React.createElement(IconButton, {
    testId: "drawer-back-to-all-products-button",
    appearance: "subtle",
    shape: "circle",
    onClick: onBackToAllProductsClick,
    label: formatMessage(messages.backToAllProducts),
    icon: ArrowLeftIcon
  })), /*#__PURE__*/React.createElement(DrawerCloseButton, {
    testId: "drawer-close-button",
    label: formatMessage(messages.close),
    icon: CrossIcon
  }));
};